export default __webpack_public_path__ + "static/media/30.ec8b110c.jpg";